/* global $ */

import React, { Component } from 'react';

import Header from './components/header.js';
import Footer from './components/footer.js';

import './App.css';

class App extends Component {
    render() {

        const { props } = this;
        const { pathname } = props.location;

        const metaTags = document.getElementsByTagName('meta');

        for(let i = 0; i < metaTags.length; i++) {
            if(metaTags[i].getAttribute('property') === 'og:url') {
                metaTags[i].setAttribute('content', location.href);
            }
            if(metaTags[i].getAttribute('property') === 'og:title') {
                if(/downloads/.test(pathname)) {
                    const title = 'Downloads - Literacy Starter'
                    document.title = title;
                    metaTags[i].setAttribute('content', title);
                } else if(/contact/.test(pathname)) {
                    const title = 'Contact - Literacy Starter'
                    document.title = title;
                    metaTags[i].setAttribute('content', title);
                } else {
                    const title = 'Literacy Starter'
                    document.title = title;
                    metaTags[i].setAttribute('content', 'Literacy Starter');
                }
            }
        }

        return (
            <div>
                <Header activeRoute={pathname} />
                <div className="container">
                    {props.children}
                </div>
                <Footer />
            </div>
        );
    }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/